import { chakra } from '@chakra-ui/react'

export const ThemeButton = chakra('button', {
    baseStyle: ({ theme }) => ({
        display: 'block',
        width: '100%',
        padding: '8px 70px 8px 16px',
        border: 0,
        fontSize: '14px',
        lineHeight: '21px',
        textAlign: 'left',
        color: theme.palette.themeToggle.textColor,
        position: 'relative',

        '& svg': {
            position: 'absolute',
            top: '11px',
            right: '16px',
            strokeWidth: '2px',
        },

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            fontSize: '16px',
            lineHeight: '24px',
            padding: '16px 40px 16px 0',

            '& svg': {
                top: '20px',
            },
        },
    }),
})

export const ThemeToggleContainer = chakra('div', {
    baseStyle: ({ theme }) => ({
        padding: '8px 0',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.themeToggle.backgroundColor,
        borderRadius: '6px',
    }),
})

/* Shared with `ThemeToggleMobile`, which already imports `ThemeButton` from here. */
export const ThemeOptionList = chakra('ul', {
    baseStyle: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
    },
})

export const ThemeOptionItem = chakra('li', {})

export const SwitchWrapper = chakra('div', {
    baseStyle: {
        display: 'inline-block',
        right: '15px',
        top: '10px',
        position: 'absolute',
    },
})

/* Keycap look; inherits the label color so it keeps the theme's text contrast. */
export const ShortcutHint = chakra('kbd', {
    baseStyle: {
        marginLeft: '8px',
        padding: '0 4px',
        border: '1px solid currentColor',
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: '12px',
        lineHeight: '18px',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
    },
})
